// extracted by mini-css-extract-plugin
export default {"cartItemUnitPrice":"cartItemUnitPrice__OWNiZ","cartItemOriginalPrice":"cartItemOriginalPrice__MzlmY","smaller":"smaller__ODYwY"};